import React from 'react';

import gogglesBottomView from '../../../main/assets/images/fpvonepilot/goggles-bottom-view.webp';

export const VisualExperiance = () => {
  return (
    <section className="fpv-pilot-visual-container">
      <div className="fpv-pilot-visual-section">
        <div className="fpv-pilot-visual-content">
          <div className="fpv-pilot-visual-text">
            <div className="fpv-pilot-visual-titles">
              <h3 className="fpv-pilot-visual-subtitle">New optics engine</h3>
              <h2 className="fpv-pilot-visual-title">
                <span className="fpv-pilot-visual-title-span">
                  Adapt visual
                </span>
                <span className="fpv-pilot-visual-title-span">
                  experience to
                </span>
                <span className="fpv-pilot-visual-title-span">your eyes</span>
              </h2>
            </div>
            <p className="fpv-pilot-visual-description">
              New optics engine brings unprecedented fine-tuning capabilities.
            </p>
          </div>
          <div className="fpv-pilot-visual-specs">
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">
                Screen resolution
              </h3>
              <p className="fpv-pilot-visual-spec-description">
                1280 x 960 pixels
              </p>
            </div>
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">Aspect ratio</h3>
              <p className="fpv-pilot-visual-spec-description">
                4:3 Native or 16:9 (720p)
              </p>
            </div>
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">Integrated DVR</h3>
              <p className="fpv-pilot-visual-spec-description">
                1280x960, 50/60fps, H.264, mp4
              </p>
            </div>
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">Viewing angle</h3>
              <p className="fpv-pilot-visual-spec-description">37°</p>
            </div>
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">Focus adjust</h3>
              <p className="fpv-pilot-visual-spec-description">-4D - +4D</p>
            </div>
            <div className="fpv-pilot-visual-specification">
              <h3 className="fpv-pilot-visual-spec-subtitle">
                HDMI video input
              </h3>
              <p className="fpv-pilot-visual-spec-description">Micro HDMI</p>
            </div>
          </div>
        </div>
        <div className="fpv-pilot-visual-image">
          <img
            src={gogglesBottomView}
            alt="Diopter Adjustment Wheel"
            className="fpv-pilot-visual-product"
          />
        </div>
      </div>
    </section>
  );
};
